import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SourcesContainer from '../../shared/SourcesContainer';
import SourceItem from '../../shared/SourceItem';
import styles from '../../styles.css';
import { templates } from './constants';

function Import({ setSourceUrl }) {
  const [selectedTemplate, setSelectedTemplate] = useState(templates[0]);

  useEffect(() => {
    setSourceUrl(selectedTemplate.url);
  }, [selectedTemplate.url]);

  const renderTemplates = () => {
    return (
      <div className={styles.templates}>
        {templates.map((template, index) => (
          <SourceItem
            key={`import-template-${template?.id}`}
            index={index}
            selectedTemplateId={selectedTemplate.id}
            setSelectedTemplate={setSelectedTemplate}
            sourceLabel={template.label}
            template={template}
            setSourceUrl={() => setSourceUrl(template.url)}
          />
        ))}
      </div>
    );
  };

  return (
    <SourcesContainer
      selectedTemplate={selectedTemplate}
      templates={renderTemplates()}
      isLocalizedDesc={false}
    />
  );
}

Import.propTypes = {
  setSourceUrl: PropTypes.func,
};

export default Import;
